module.exports = __webpack_public_path__ + "img/image-not-found.6017e4da.jpg";